const e=async(e,t,n)=>{await e.put(`/apps/${t}`,n)};export{e as updateApp};
//# sourceMappingURL=update-app.mjs.map